import { PureComponent } from "react";
import CommingSoon from "../../components/comming-soon";
import "./Projects.css";
import {  Card, CardContent, CardDescription, CardHeader, CardMeta, Grid, GridColumn, Icon, Image } from "semantic-ui-react";

const projects = [
    {name:"print-table",link:"https://www.npmjs.com/package/@yungkei/print-table",type:"npm",language:"javascript",description:"A tiny javascript library to help printing table from the web.",author:"yungkei",repository:"https://github.com/yungkei/print-table"},
    {name:"yhttpcmd",link:"https://hub.docker.com/r/yungkei/yhttpcmd",type:"docker",language:"golang",description:"yhttpcmd is a tiny cmd2http(convert command as http service) server.",author:"yungkei",repository:"https://github.com/yungkei/yhttpcmd"},
]

class Projects extends PureComponent {
    render() {
        return <div className="Projects">{
                projects.length === 0?<CommingSoon />:
                    <Grid columns='4' className="Grid">
                    {
                        projects.map(item => {
                            const {name="",link="",type="",description="",author="",repository=""}=item||{}
                            return (
                                <GridColumn className="GridColumn">
                                <Card className="Card">
                                    <CardContent>
                                    <Image
                                        floated='right'
                                    >
                                    {
                                        type=="npm"&&(
                                            <a href={link}>
                                                <Icon name='npm' size="big" color="red"/>
                                            </a>
                                        )
                                    }
                                    {
                                        type=="docker"&&(
                                            <a href={link}>
                                                <Icon name='docker' size="big"/>
                                            </a>
                                        )
                                    }
                                    </Image>
                                        <CardHeader>{name}</CardHeader>
                                        <CardMeta>
                                            <span>author: {author}</span>
                                        </CardMeta>
                                        <CardDescription>
                                            {description}
                                        </CardDescription>
                                    </CardContent>
                                    <CardContent extra>
                                    <a href={repository}>
                                        <Icon name='github' />
                                        repository
                                    </a>
                                    </CardContent>
                                </Card>
                                </GridColumn>
                            )
                        })
                    }
                </Grid>
                }
        </div>
    }
}

export default Projects;